import _taggedTemplateLiteral from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n\n  .active-or-complete {\n    background-color: var(--teal);\n    color: white;\n  }\n\n  .step-circle {\n    border-radius: 50%;\n    border: 1px solid var(--text);\n    height: 24px;\n    width: 24px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .step {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    position: relative;\n    flex: 1;\n    font-size: 0.875rem;\n    padding: 0 10px;\n  }\n\n  .step p {\n    text-align: center;\n    margin-bottom: 0;\n    font-size: 0.875rem;\n  }\n\n  .step .connector {\n    position: absolute;\n    top: 12px;\n    left: calc(-50% + 20px);\n    right: calc(50% + 20px);\n    border-bottom: 1px solid var(--text);\n  }\n\n  @media (max-width: 374px) {\n    .step .connector {\n      display: none;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
var StyledProgressStepper = styled.div(_templateObject());
;
export var ProgressStepper = function ProgressStepper(_ref) {
  var activeStepIndex = _ref.activeStepIndex,
      stepLabels = _ref.stepLabels,
      className = _ref.className;
  return React.createElement(StyledProgressStepper, {
    className: className || ''
  }, stepLabels.map(function (stepLabel, index) {
    return React.createElement("div", {
      className: "step",
      key: "".concat(stepLabel)
    }, React.createElement("div", {
      className: "step-circle ".concat(index <= activeStepIndex ? 'active-or-complete' : '')
    }, activeStepIndex <= index && index + 1, activeStepIndex > index && React.createElement("i", {
      className: "far fa-check"
    })), React.createElement("p", null, stepLabel), index !== 0 && React.createElement("div", {
      className: "connector"
    }));
  }));
};